import { useContext, useState } from 'react';

import { AssetContext } from '@pages/Asset/Asset.query';
import { NavigationContext } from '@layout/navigation/navigation';
import { getPermissionData, setAttr } from '@utils';
import { getProductValue } from '@utils/getProductValue';
import { ITooltip, Text as TextComponent } from '@components/index';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { Icon } from '@blueprintjs/core';
import { Container, RowButton } from './NoDocuments.styles';
// import { AddDocument } from '../AddDocument/AddDocument';
const NoDocuments = () => {
  const { openAddDocument, equipmentQuery } = useContext(AssetContext);
  const { role } = useContext(NavigationContext);
  const equipment = equipmentQuery?.data;
  const { manufacturerId, productId } = getProductValue(equipment);
  const addPermission = getPermissionData({
    owner: true,
    action: 'add',
    role,
    type: 'Document',
  });

  const hasProduct = manufacturerId && productId;
  const isEnabled = addPermission.allowed && hasProduct;
  const { isDesktop } = useSelector(checkDevice());
  const onAddDocument = () => {
    if (isEnabled) {
      openAddDocument.set(true);
    }
  };
  const [tooltipId] = useState(() => {
    return `add-documents-disabled-tooltip${Date.now()}`;
  });

  return (
    <Container>
      {isDesktop && (
        <RowButton
          className="new-icon"
          data-disabled={setAttr(!isEnabled)}
          onClick={onAddDocument}
          data-tip={addPermission.message}
          data-for={tooltipId}
        >
          <Icon icon="document" color={COLORS_FLAT.b401} />
          <TextComponent text="b200" textColor="b401">
            Add your documents
          </TextComponent>
        </RowButton>
      )}

      {/*
        <RowButton
        className="new-icon"
        disabled={setAttr(!isEnabled)}
        onClick={() => {
          if (isEnabled) {
            openAddDocument.set(true);
          }
        }}
      >
        <BlueIcon icon="document" color={COLORS_FLAT.b401} />
        <Text>Add your documents</Text>
      </RowButton>

      */}
      <TextComponent text="b200" textColor="n800" ta="center">
        You don&apos;t have any documents yet!
      </TextComponent>
      {/* <Text className="light">
        Documents can be related to a <br />
        manufacturer, a product or shown in all <br />
        your assets.
      </Text> */}
      <TextComponent text="p200" textColor="n800" maw={251}>
        Documents can be related to a manufacturer, a product or shown in all
        your assets.
      </TextComponent>
      {/* <AddDocument
        open={openAddDocument}
        onClose={() => {
          setOpenAddDocument(false);
        }}
      /> */}
      <ITooltip id={tooltipId} />
    </Container>
  );
};

export { NoDocuments };
